import { render, staticRenderFns } from "./CreditDebit.vue?vue&type=template&id=6083cb4c&"
import script from "./CreditDebit.vue?vue&type=script&lang=js&"
export * from "./CreditDebit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports